<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11XgScJ/tc-custom/9780547416496.jpg?1737055746743" alt="This image is the cover for the book Strokes of Genius"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strokes of Genius
      </h1>
      <p class="bookDescription body article font2">
        <b>The executive editor of <i>Sports Illustrated </i>offers an in-depth analysis and behind-the-scenes look at the historic 2008 match between tennis titans.</b><br/>  <br/> In the 2008 Wimbledon men’s final, Centre Court was a stage set worthy of Shakespearean drama. Five-time champion Roger Federer was on track to take his rightful place as the most dominant player in the history of the game. He just needed to cling to his trajectory. So, in the last few moments of daylight, Centre Court witnessed a coronation. Only it wasn’t a crowning for the Swiss heir apparent but for a swashbuckling Spaniard. Twenty-two-year-old Rafael Nadal prevailed, in five sets, in what was, according to the author, “essentially a four-hour, forty-eight-minute infomercial for everything that is right about tennis—a festival of skill, accuracy, grace, strength, speed, endurance, determination, and sportsmanship.” It was also the encapsulation of a fascinating rivalry, hard fought and of historic proportions.<br/>  <br/> In the tradition of John McPhee’s classic <i>Levels of the Game</i>,<i> Strokes of Genius </i>deconstructs this defining moment in sport, using that match as the backbone of a provocative, thoughtful, and entertaining look at the science, art, psychology, technology, strategy, and personality that go into a single tennis match. With vivid, intimate detail, Wertheim re-creates this epic battle in a book that is both a study of the mechanics and art of the game and the portrait of a rivalry as dramatic as that of Ali–Frazier, Palmer–Nicklaus, and McEnroe–Borg.<br/>  <br/><b>“Deftly touches on all the defining factors of contemporary tennis.” —<i>San Francisco Chronicle</i></b><br/>  <br/><b>“Illuminates a kingdom changing hands. An engrossing book.” —Bud Collins</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L. Jon Wertheim
      </h2>
      
      <p class="authorDescription body article">L. JON WERTHEIM is a senior writer for Sports Illustrated and the author of five books, including Blood in the Cage, a chronicle of the rise of mixed martial arts, and Running the Table, about a bipolar pool hustler named Kid Delicious, which has been optioned for film by Tom Hanks's Playtone and is currently in development. His work has been featured in The Best American Sports Writing numerous times.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a4129e0